export default __webpack_public_path__ + "media/images/logo-symbol-wordmark-6742d75a9f41497996b0eaa11307ca9c.svg";